// @owners { team: patients-team }
import { COLORS } from '@alto/design-library-tokens';
import { Card, SecondaryPage, SmPadding } from '@alto/design-system';
import { ReplyForm as ReplyFormComponent } from '@alto/features';
import React from 'react';
import { useParams } from 'react-router-dom';

export const ReplyForm = () => {
  const { supportCaseID } = useParams<{ supportCaseID: string }>();

  return (
    <SecondaryPage headerBackgroundColor={COLORS.BACKGROUND_COLORS.SECONDARY_LIGHTEST}>
      <Card>
        <SmPadding>
          <ReplyFormComponent params={{ supportCaseID: Number(supportCaseID) }} />
        </SmPadding>
      </Card>
    </SecondaryPage>
  );
};
